<template>
  <div>
    <Drawer
      :closable="false"
      v-model="logisticsChannelDrawer"
      width="1000"
      :title="$t('key1000222')"
      :transfer="false"
      :lock-scroll="true"
      class-name="logisticsChannelStyle"
      @on-visible-change="visibleChange">
      <!--筛选-->
      <div class="filter_box">
        <span>{{ $t('key1005219') }}</span>
        <Input v-model.trim="logisticsChannelText" clearable style="width: 250px;"></Input>
      </div>
      <!--未启用物流方式、新增自定义物流-->
      <div class="options_boxs" v-if="getPermission('carrierShippingMethod_queryForDisableShippingMethods')">
        <!--新增物流渠道-->
        <Button class="mr15" v-if="carrierCode === 'temuHalfTl' || carrierType !== 0" type="primary" @click="addCustomLogisticsBtn">{{ $t('key1005220') }}</Button>
        <!--未启用物流方式-->
        <Poptip :transfer="true" v-model="disbaleShippingMethodModel"
          @on-popper-show="getShppingMethodData" placement="top-end" width="400">
          <Button icon="md-add" type="primary">{{ $t('key1005221') }}</Button>
          <template #content>
            <div>
              <Input
                v-model="disableShippingMethodSearchName"
                :placeholder="$t('key1005218')"
                @on-enter="searchDisableShippingMehotd">
              </Input>
              <div class="disableTable">
                <Table
                  highlight-row
                  :border="false"
                  :show-header="false"
                  :stripe="false"
                  :columns="disbaleShippingMethodColumns"
                  :data="disbaleShippingMethodData"
                  size="small"
                  height="150"
                  @on-selection-change="getDisableSelectValue">
                </Table>
              </div>
              <div style="display: flex; justify-content: flex-end;align-items: center; margin-top: 15px;">
                <Button size="small" style="margin: 0 10px 5px 0" @click="disbaleShippingMethodModel = false">{{ $t('key1000112') }}</Button>
                <Button type="primary" size="small" style="margin: 0 10px 5px 0" @click="enableShippingMethod">{{ $t('key1000111') }}</Button>
              </div>
            </div>
          </template>
        </Poptip>
      </div>
      <!--列表-->
      <Table ref="tableDom" highlight-row border :columns="logistiChannelColumns" :data="logistiChannelData" max-height="750"></Table>
    </Drawer>
    <!--物流渠道-->
    <logisticsChannelModal ref="logisticsChannel" @updateData="updateData" :accept="carrierType"></logisticsChannelModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import logisticsChannelModal from "@/views/yms/components/logisticsManage/logisticsChannelModal";
import {_handleMultilingualFields} from "@/utils/common";

export default {
  name: "viewLogisticsChannel",
  mixins: [Mixin],
  data() {
    return {
      logisticsChannelDrawer: false,
      logisticsChannelText: '',
      logistiChannelColumns: [],
      logistiChannelData: [],
      originalData: [],
      disbaleShippingMethodModel: false,
      disbaleShippingMethodData: [],
      carrierId: null,
      apiInterface: '',
      disableShippingMethodSearchName: '',
      disableSystemCarrierId: [],
      disbaleShippingMethodColumns: [
        {
          type: 'selection',
          width: 60,
          align: 'center',
          render: (h, params) => {
            return params;
          }
        }, {
          title: 'name',
          key: 'carrierShippingMethodName'
        }
      ],
      carrierCode: null,
      isOnline: null,
      carrierType: null
    };
  },
  methods: {
    // 监听Drawer抽屉的状态
    visibleChange(value) {
      if (!value) {
        this.logisticsChannelText = '';
        this.originalData = [];
        this.logistiChannelColumns = [];
        this.logistiChannelData = [];
      }
    },
    // 初始化数据
    initViewLogisticsChannelData(obj) {
      let {carrierId, apiInterface, carrierCode, carrierType, isOnline} = obj;
      this.carrierId = carrierId;
      this.apiInterface = apiInterface;
      this.carrierCode = carrierCode;
      this.carrierType = carrierType;
      this.isOnline = isOnline;
      this.getList(this.carrierId, this.apiInterface);
    },
    // 获取列表的数据
    getList(carrierId, apiInterface) {
      let v = this;
      v.optionBtnWidth = [];
      let params = `?carrierId=${carrierId}&status=1`;
      v.axios.get(api.get_carrierShippingMethod_queryForEnableShippingMethods + params, {loading: true}).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          let newData = v.handleMultilinguaTableFields(data, ['carrierShippingMethodName']);
          // 选择速卖通线上发货时，需重新设置物流渠道的表头
          if (apiInterface === 'API_AE_LG') {
            v.logistiChannelColumns = [
              {
                key: 'carrierShippingMethodName',
                title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002818'),
                align: 'center',
                width: 160,
                render: (h, params) => {
                  return h('div', [
                    h('span', params.row.carrierShippingMethodName)
                  ]);
                }
              },
              {
                key: 'carrierShippingMethodCode',
                align: 'center',
                title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000409'),
                width: 160,
                render: (h, params) => {
                  return h('div', [
                    h('span', params.row.carrierShippingMethodCode)
                  ]);
                }
              },
              {
                key: 'logisticsInterface',
                align: 'center',
                title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005212'),
                minWidth: 160,
                render: (h, params) => {
                  return h('div', [
                    h('span', params.row.logisticsInterface)
                  ]);
                }
              },
              {
                title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000410'),
                align: 'center',
                width: 120,
                render: (h, params) => {
                  return h('div', [
                    h('span', params.row.minEfficiency),
                    h('span', ' - '),
                    h('span', params.row.maxEfficiency),
                    h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001631'))
                  ]);
                }
              },
              {
                title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003698'),
                align: 'center',
                width: 130,
                render: (h, params) => {
                  if (params.row.hasTrackingNumber) {
                    return h('div', 'Y');
                  } else {
                    return h('div', 'N');
                  }
                }
              },
              {
                title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005213'),
                align: 'center',
                width: 140,
                key: 'senderAddressId'
              },
              {
                title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005214'),
                align: 'center',
                width: 140,
                key: 'pickupAddressId'
              }, {
                title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005215'),
                align: 'center',
                width: 140,
                key: 'refundAddressId'
              },
              {
                key: 'operate',
                align: 'center',
                title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
                fixed: 'right',
                width: 130,
                render: (h, params) => {
                  let shippingMethodId = params.row.shippingMethodId;
                  return h('optsButtonList', {
                    props: {
                      operationList: [
                        {
                          text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401'),
                          show: v.getPermission('carrierShippingMethod_detail'),
                          clickFn: () => {
                            v.$refs['logisticsChannel'].initLogisticsChannelData('look', shippingMethodId);
                            v.$refs['logisticsChannel'].carrierCode = v.carrierCode;
                          }
                        },
                        {
                          text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000669'),
                          show: v.getPermission('carrierShippingMethod_update'),
                          clickFn: () => {
                            v.$refs['logisticsChannel'].initLogisticsChannelData('edit', shippingMethodId);
                            v.$refs['logisticsChannel'].carrierCode = v.carrierCode;
                          }
                        },
                        {
                          text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000003'),
                          show: v.getPermission('carrierShippingMethod_update'),
                          clickFn: () => {
                            v.copyLogisticsChannels(shippingMethodId)
                          }
                        },
                        {
                          text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'),
                          show: true,
                          clickFn: () => {
                            v.stopShippingMethod(params.row.shippingMethodId, params.row.carrierId, '', apiInterface);
                          }
                        }
                      ]
                    },
                    on: {
                      setWidth(value) {
                        if (value) {
                          v.optionBtnWidth.push(value);
                          params.column.width = Math.max(...v.optionBtnWidth);
                          v.$forceUpdate();
                        }
                      }
                    }
                  });
                }
              }
            ];
          } else {
            v.logistiChannelColumns = [
              {
                key: 'carrierShippingMethodName',
                title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002818'),
                align: 'center',
                width: 160,
                render: (h, params) => {
                  return h('div', [
                    h('span', params.row.carrierShippingMethodName)
                  ]);
                }
              }, {
                key: 'carrierShippingMethodCode',
                align: 'center',
                title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000409'),
                width: 160,
                render: (h, params) => {
                  return h('div', [
                    h('span', params.row.carrierShippingMethodCode)
                  ]);
                }
              }, {
                key: 'logisticsInterface',
                align: 'center',
                title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005212'),
                minWidth: 160,
                render: (h, params) => {
                  return h('div', [
                    h('span', params.row.logisticsInterface)
                  ]);
                }
              }, {
                title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000410'),
                align: 'center',
                width: 120,
                render: (h, params) => {
                  let minEfficiency = params.row.minEfficiency;
                  let maxEfficiency = params.row.maxEfficiency;
                  let text = '';
                  if (minEfficiency && !maxEfficiency) {
                    text = minEfficiency + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001631');
                  }
                  if (maxEfficiency && !minEfficiency) {
                    text = maxEfficiency + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001631');
                  }
                  if (minEfficiency && maxEfficiency) {
                    text = minEfficiency + ' - ' + maxEfficiency + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001631');
                  }
                  return h('div', text);
                }
              }, {
                title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003698'),
                align: 'center',
                width: 120,
                render: (h, params) => {
                  if (params.row.hasTrackingNumber) {
                    return h('div', 'Y');
                  } else {
                    return h('div', 'N');
                  }
                }
              },
              {
                key: 'operate',
                align: 'center',
                title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
                width: 130,
                render: (h, params) => {
                  let isE = params.row.status === 1;
                  let shippingMethodId = params.row.shippingMethodId;
                  return h('optsButtonList', {
                    props: {
                      operationList: [
                        {
                          text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401'),
                          show: v.getPermission('carrierShippingMethod_detail'),
                          clickFn: () => {
                            v.$refs['logisticsChannel'].initLogisticsChannelData('look', shippingMethodId, params.index);
                            v.$refs['logisticsChannel'].carrierCode = v.carrierCode;
                          }
                        },
                        {
                          text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000669'),
                          show: v.getPermission('carrierShippingMethod_update'),
                          clickFn: () => {
                            v.$refs['logisticsChannel'].initLogisticsChannelData('edit', shippingMethodId, params.index);
                            v.$refs['logisticsChannel'].carrierCode = v.carrierCode;
                          }
                        },
                        {
                          text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000003'),
                          show: v.getPermission('carrierShippingMethod_update'),
                          clickFn: () => {
                            v.copyLogisticsChannels(shippingMethodId, params.index)
                          }
                        },
                        {
                          text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'),
                          show: !isE && v.getPermission('carrierShippingMethod_enable'),
                          clickFn: () => {
                            v.stopShippingMethod(params.row.shippingMethodId, params.row.carrierId, true, apiInterface);
                          }
                        },
                        {
                          text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'),
                          show: isE && v.getPermission('ymsLogisServiceMapping_disable'),
                          clickFn: () => {
                            v.stopShippingMethod(params.row.shippingMethodId, params.row.carrierId, false, apiInterface);
                          }
                        }
                      ]
                    },
                    on: {
                      setWidth(value) {
                        if (value) {
                          v.optionBtnWidth.push(value);
                          params.column.width = Math.max(...v.optionBtnWidth);
                          v.$forceUpdate();
                        }
                      }
                    }
                  });
                }
              }
            ];
          }
          v.logistiChannelData = newData;
          v.originalData = newData;
          v.updateTableDom('tableDom', 1000, false, 'logistiChannelData');
          v.logisticsChannelDrawer = true;
        }
      });
    },
    // 启用、停用
    stopShippingMethod(id, cid, isEnable, apiInterface) {
      let v = this;
      if (isEnable) {
        // 自定义 启用
        let query = {
          carrierId: cid,
          shippingMethodEnableDetails: [
            {
              shippingMethodId: id
            }
          ]
        };
        v.axios.put(api.put_carrierShippingMethod_enable, query).then(response => {
          if (response.data.code === 0) {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
            v.getList(cid, apiInterface);
          }
        });
      } else {
        // 停用
        v.axios.get(api.get_ymsLogisServiceMapping_disable + id).then(response => {
          if (response.data.code === 0) {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
            v.getList(cid, apiInterface);
          }
        });
      }
    },
    // 勾选中未启用物流方式的数据
    getDisableSelectValue(value) {
      let v = this;
      let pos = [];
      if (value.length) {
        Promise.resolve(value.forEach((n, i) => {
          pos.push({
            shippingMethodId: n.shippingMethodId,
            systemShippingMethodId: n.systemShippingMethodId
          });
        })).then(() => {
          v.disableSystemCarrierId = pos;
        });
      } else {
        v.disableSystemCarrierId = [];
      }
    },
    // 获取未启用物流方式的数据
    getShppingMethodData(searchName) {
      let v = this;
      let value = '?carrierId=' + v.carrierId;
      if (searchName) value = value + '&&searchName=' + searchName;
      v.axios.get(api.get_carrierShippingMethod_queryForDisableShippingMethods + value).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          if (data.length > 0) {
            data.forEach((item) => {
              item.carrierShippingMethodName = _handleMultilingualFields(item.carrierShippingMethodName);
            });
          }
          v.disbaleShippingMethodData = data;
        }
      });
    },
    // 启用物流商物流方式
    enableShippingMethod() {
      let v = this;
      if (v.disableSystemCarrierId.length === 0) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005216'));
        return false;
      }
      let obj = {
        carrierId: v.carrierId,
        shippingMethodEnableDetails: v.disableSystemCarrierId
      };
      v.axios.put(api.put_carrierShippingMethod_enable, JSON.stringify(obj), {loading: true}).then(response => {
        if (response.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
          v.getShppingMethodData();
          v.getList(v.carrierId, v.apiInterface);
          v.$emit('updateData', true);
          v.disableSystemCarrierId = [];
          v.disbaleShippingMethodModel = false;
        }
      });
    },
    // 搜索未启用的物流方式
    searchDisableShippingMehotd() {
      let v = this;
      v.getShppingMethodData(v.disableShippingMethodSearchName);
    },
    // 新增自定义物流
    addCustomLogisticsBtn() {
      this.$refs['logisticsChannel'].initLogisticsChannelData('addCustom', null, null);
      this.$refs['logisticsChannel'].carrierCode = this.carrierCode;
      this.$refs['logisticsChannel'].isOnline = this.isOnline;
    },
    updateData() {
      this.getList(this.carrierId, this.apiInterface);
      this.$emit('updateData', true);
    },
    // 复制物流渠道
    copyLogisticsChannels(shippingMethodId) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000330'),
        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005217'),
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000111'),
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
        onOk: () => {
          v.$refs['logisticsChannel'].initLogisticsChannelData('copy', shippingMethodId)
          v.$refs['logisticsChannel'].carrierCode = v.carrierCode;
          v.$refs['logisticsChannel'].isOnline = v.isOnline;
        },
        onCancel: () => {

        }
      });
    }
  },
  watch: {
    // 模糊搜索物流渠道名称/代码
    logisticsChannelText: {
      handler(value) {
        let newListData = [];
        if (value !== '') {
          let text = value.toLowerCase();
          if (this.logistiChannelData.length > 0) {
            this.logistiChannelData.filter(item => {
              if (item.carrierShippingMethodCode.toLowerCase().indexOf(text) !== -1 || item.carrierShippingMethodName.toLowerCase().indexOf(text) !== -1) {
                newListData.push(item);
              }
            });
            this.logistiChannelData = newListData;
          }
        } else {
          this.logistiChannelData = this.originalData;
        }
      },
      deep: true
    },
    // 关闭未启用物流方式提示框时，重置数据
    disbaleShippingMethodModel: {
      handler(value) {
        if (!value) {
          let v = this;
          v.disableShippingMethodSearchName = '';
          v.disbaleShippingMethodData = [];
          v.disableSystemCarrierId = [];
        }
      }
    }
  },
  components: {
    logisticsChannelModal
  }
};
</script>

<style lang="less" scoped>
/deep/ .logisticsChannelStyle {
  position: relative;

  .filter_box {
    display: flex;
    align-items: center;
    margin: 10px 0 15px 0;
  }

  .options_boxs {
    position: absolute;
    top: -42px;
    right: 16px;
  }

  .ivu-drawer-body {
    overflow: initial !important;
  }

  .ivu-drawer .ivu-drawer-header-inner {
    font-size: 18px;
    font-weight: bold;
    color: #333;
  }
}
</style>